module.exports = __webpack_public_path__ + "static/media/Emily02_thumb.ad53640f.png";